console.log("image-modal loaded");

// Add this function to check for touch devices
function isTouchDevice() {
  return window.matchMedia("(hover: none)").matches;
}

// Add this function to set up click handlers
function setupImageZoom() {
  const productImages = document.querySelectorAll(".product-page-image");

  productImages.forEach((media) => {
    // Only add click handlers on non-touch devices and exclude instruction media
    if (
      !isTouchDevice() &&
      !media.classList.contains("instruction-media-image")
    ) {
      // Bind once per image. The PDP modal re-runs the product scripts on every
      // open and never removes the prior run's ready-event listeners, so without
      // this guard setupImageZoom fires N times on the Nth open and each image
      // ends up with N click handlers — one click then opens the zoom modal N
      // times (stacking duplicate <video> nodes). Every other product-init is
      // already guarded against re-fire; this was the one hole.
      if (media.dataset.zoomBound === "1") return;
      media.dataset.zoomBound = "1";
      media.addEventListener("click", function () {
        openModal(this);
      });
      media.style.cursor = "zoom-in";
    }
  });
}

function openModal(mediaElement) {
  // Only proceed if not a touch device
  if (isTouchDevice()) return;

  var modal = document.getElementById("image-expand");
  var modalImg = document.getElementById("modalImage");
  var closeIcon = document.querySelector(".IMAGE_MODAL_CL_CLOSE");
  var productImage = document.querySelector(".product-page-image");

  if (mediaElement.tagName === "VIDEO") {
    // Handle video — clear any video left from a prior open so they can't stack.
    modal.querySelectorAll("video").forEach((v) => {
      v.pause();
      v.remove();
    });
    modalImg.style.display = "none";
    var modalVideo = document.createElement("video");
    modalVideo.src = mediaElement.querySelector("source").src;
    modalVideo.controls = true;
    modalVideo.style.width = "100%";
    modalVideo.style.height = "auto";
    modalVideo.style.maxHeight = "90vh";
    modal.appendChild(modalVideo);
    modalVideo.play(); // Optional: autoplay
  } else {
    // Handle image
    modalImg.src = mediaElement.src;
    modalImg.style.display = "block";
    productImage.style.cursor = "zoom-out";
  }

  modal.style.display = "flex";
  closeIcon.style.display = "block";
  modal.scrollTop = 0;
  modal.scrollLeft = (modal.scrollWidth - modal.clientWidth) / 0;
}

function closeModal() {
  // Only proceed if not a touch device
  if (isTouchDevice()) return;

  var modal = document.getElementById("image-expand");
  var closeIcon = document.querySelector(".IMAGE_MODAL_CL_CLOSE");
  var productImage = document.querySelector(".product-page-image");

  // Remove any video elements in the modal
  var modalVideo = modal.querySelector("video");
  if (modalVideo) {
    modalVideo.pause();
    modal.removeChild(modalVideo);
  }

  modal.style.display = "none";
  closeIcon.style.display = "none";
  productImage.style.cursor = "zoom-in";
}

// Initialize zoom functionality when DOM is loaded
document.addEventListener("DOMContentLoaded", setupImageZoom);
